import PageBody from "../PageBody";
import Companies from "../components/pages/companies/Companies";

const CompaniesPage = () => {
  return (
    <PageBody>
      <Companies />
    </PageBody>
  );
};

export default CompaniesPage;
